"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadModule = loadModule;
/**
 * Loads dynamically a CommonJs module.
 *
 * @param moduleJs Js code of the module
 * @param require require() function providing the module dependencies
 */
function loadModule(moduleJs, require) {
    const module = { exports: {} };
    // eslint-disable-next-line no-new-func
    new Function('require', 'module', 'exports', moduleJs)(require, module, module.exports);
    return module.exports;
}
//# sourceMappingURL=commonjs_loader.js.map